import script from "./MapControls.vue?vue&type=script&setup=true&lang=js"
export * from "./MapControls.vue?vue&type=script&setup=true&lang=js"

import "./MapControls.vue?vue&type=style&index=0&id=39267885&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39267885"]])

export default __exports__